const routes = {
  path: '/retentions',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/retentions',
      name: 'list-retentions',
      component: () => import('../views/Retention/Index.vue'),
      meta: {
        pageTitle: 'Retenções',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Retenções', active: true }],
      },
    },
    {
      path: '/retentions/occurrences',
      name: 'retention-occurrences',
      component: () => import('../views/Retention/Occurrences.vue'),
      meta: {
        pageTitle: 'Lançar retenção',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'Retenções', to: { name: 'list-retentions' } },
          { text: 'Lançar', active: true },
        ],
      },
    },
    {
      path: '/retentions/:id',
      name: 'retention-detail',
      component: () => import('../views/Retention/Detail.vue'),
      meta: {
        pageTitle: 'Retenção',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'Retenções', to: { name: 'list-retentions' } },
          { text: 'Detalhe', active: true },
        ],
      },
    },
  ],
}

export default routes
